import React from "react";
import { DEFAULT_DEBOUNCE_TIMEOUT } from "consts";
import { getLocations } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const LocationAutoSuggest = (props) => {
    const suggestLocation = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        }

        return Promise.resolve(
            getLocations().then((data) => {
                return data
                    .filter((location) => (location.title || "")
                        .toLocaleLowerCase()
                        .includes(q)
                    );
            })
        );
    };

    return (
        <AutoSuggest
            label="Location"
            fetchOptions={(q) => suggestLocation(q)}
            renderOption={(location) => ({ value: location, label: location.title })}
            optionIdentifier={(location) => location.title}
            debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
            {...props}
        />
    );
}

export default LocationAutoSuggest;
